(function () {
  if (!customElements.get("mobile-filters")) {
    customElements.define(
      "mobile-filters",
      class MobileFilters extends HTMLElement {
        constructor() {
          super();
          this.filterDetails = [...this.querySelectorAll("details")];

          this.currentFilterEl = this.querySelector(".js-current-filter");
          this.closeAllBtn = this.querySelector(".js-close-all");
          this.closeInnerBtn = this.querySelector(".js-close-inner");

          this.onToggle = this.onToggle.bind(this);
          this.innerClose = this.innerClose.bind(this);
        }

        toggleButtons() {
          this.closeAllBtn?.classList.toggle("hidden");
          this.closeInnerBtn?.classList.toggle("hidden");
        }

        innerClose() {
          this.filterDetails.forEach((detail) => {
            if (detail.open) {
              detail.removeAttribute("open");
              detail.classList.remove("open");
            } else {
              detail.classList.remove("hidden");
            }
          });
          this.toggleButtons();
          this.currentFilterEl.innerText = "Filter";
        }
        connectedCallback() {
          this.filterDetails.forEach((detail) => {
            detail.addEventListener("toggle", this.onToggle);
          });
          this.closeInnerBtn.addEventListener("click", this.innerClose);
        }

        disconnectedCallback() {
          this.filterDetails.forEach((detail) => {
            detail.removeEventListener("toggle", this.onToggle);
          });
          this.closeInnerBtn.removeEventListener("click", this.innerClose);
        }
        onToggle(e) {
          const toggledDetail = e.currentTarget;
          if (toggledDetail.open) {
            this.toggleButtons();
            this.currentFilterEl.innerText =
              toggledDetail.querySelector("span")?.innerText;
            this.filterDetails.forEach((detail) => {
              detail !== toggledDetail
                ? detail.classList.add("hidden")
                : detail.classList.add("open");
            });
          }
        }
      }
    );
  }
})();
